import { useState } from 'react';
import Hero from '../components/Hero';
import Navigation from '../components/Navigation';
import Intro from '../components/Intro';
import Accommodations from '../components/Accommodations';
import BookingSection from '../components/BookingSection';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import PropertyModal from '../components/PropertyModal';

const Home = () => {
  const [selectedProperty, setSelectedProperty] = useState(null);

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <Intro />
      <Accommodations onSelectProperty={setSelectedProperty} />
      <BookingSection />
      <FAQ />
      <Footer />
      
      {selectedProperty && (
        <PropertyModal 
          property={selectedProperty} 
          onClose={() => setSelectedProperty(null)} 
        />
      )}
    </div>
  );
};

export default Home;